/**
 * WaitlistsPage — the Coming soon page Home's Waitlist chip opens, in the Invite
 * page's card (web-account-pages D10). Display only; joining a waitlist is still
 * to come. A ClientShell child (it reads the studio name and fills the header slot).
 *
 * Visual authority: docs/mockups/telify-web/phone-signed-in/waitlists.html.
 */
import { ComingSoonPage, type ComingSoonCopy } from '@/pages/client/ComingSoonPage';

export const waitlistsCopy = (businessName: string): ComingSoonCopy => ({
  kicker: "Something's coming",
  title: ['Save your place', 'in line'],
  body: `Soon you'll be able to join the waitlist for a full session at ${businessName}.`,
  foot: 'Arriving in a future update',
});

export function WaitlistsPage() {
  return <ComingSoonPage headerTitle="Waitlists" testId="waitlists-page" copy={waitlistsCopy} />;
}
